<template>
  <div
  class="operationLog"
  v-loading="isLoading"
  element-loading-text="数据加载中">
    <el-row class="title" v-if="isViewTitle">
      <breadCrubm :navMenu="['用户日志']">
      </breadCrubm>
    </el-row>
    <div class="content" :style="{height: isViewTitle ? '' : '100%'}">
      <el-radio-group class="tab-menu" v-model="tabVal" @input="changeTabVal">
        <el-radio-button label="login">登录日志</el-radio-button>
        <el-radio-button label="log">操作日志</el-radio-button>
      </el-radio-group>
      <div class="search">
        <el-form class="form">
          <template v-for="list in searchConfig[tabVal]" :key="list.prop">
            <el-form-item :label="list.name">
              <el-input
                style="margin-left: 10px"
                v-if="list.type === 'text'"
                v-model="search[list.prop]"
                :style="'width: ' + list.width"
                @change="getList"
                size="small"></el-input>
              <el-date-picker
                :style="'width: ' + list.width"
                v-else-if="list.type === 'time'"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="timestamp"
                @change="getList"
                v-model="search[list.prop]"></el-date-picker>
              <el-select
                :style="'width: ' + list.width"
                v-else-if="list.type === 'select'"
                @change="getList"
                v-model="search[list.prop]">
                <el-option
                  v-for="item in list.config"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </template>
          <el-form-item style="margin-left: 10px">
            <el-button size="small" @click="getList">搜索</el-button>
            <el-button size="small" @click="searchReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table" v-loading="isLoading">
        <el-table
          :stripe="true"
          :data="tableInfo"
          :header-cell-style="{ background: '#f8f9fb', color: '#333', fontWeight: 'normal' }"
          height="100%"
          border
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            :label="list.name"
            v-for="(list) in tableConfig[tabVal]"
            :key="list.prop"
            :min-width="list.width">
            <template v-slot="scope">
              <el-popover
                v-if="list.prop === 'name' || list.prop === 'haddlename'"
                placement="top-start"
                trigger="hover">
                <div class="popover-class">身份证号：{{list.prop === 'name' ? scope.row.idcard : scope.row.haddleidcard}}</div>
                <template #reference>
                  <span style="cursor: pointer;">{{scope.row[list.prop]}}</span>
                </template>
              </el-popover>
              <template v-else>
                {{list.fun ? list.fun(scope.row[list.prop]) : scope.row[list.prop]}}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" v-show="total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="query.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getuserloginlist, getuserloglist } from '@/port/admins/operationLog'
import breadCrubm from './common/breadCrubm.vue'
export default {
  name: 'operationLog',
  components: {
    breadCrubm,
  },
  data () {
    return {
      tabVal: 'login',
      search: {
        time: [],
        type: '',
        theWay: '',
        input: ''
      },
      searchConfig: {
        login: [
          {
            name: '日期',
            prop: 'time',
            type: 'time',
            width: '220px'
          },
        ],
        log: [
          {
            name: '操作时间',
            prop: 'time',
            type: 'time',
            width: '220px'
          },
          {
            name: '行为',
            prop: 'type',
            type: 'select',
            width: '160px',
            config: [
              {
                label: '添加部门管理员',
                value: 2
              },
              {
                label: '移除部门管理员',
                value: 3
              },
              {
                label: '删除成员',
                value: 4
              },
              {
                label: '密码修改',
                value: 5
              }
            ]
          },
          {
            name: ' ',
            prop: 'theWay',
            type: 'select',
            width: '160px',
            config: [
              {
                label: '对象（按姓名）',
                value: 'haddlename'
              },
              {
                label: '操作人（按姓名）',
                value: 'name'
              }
            ]
          },
          {
            name: '',
            prop: 'input',
            type: 'text',
            width: '220px'
          }
        ]
      },
      tableConfig: {
        login: [
          {
            name: '类型',
            prop: 'type',
            fun: function (val) {
              const obj = {
                1: '登录',
                3: '第三方登录',
                4: '企业微信登录'
              }
              return obj[val] ? obj[val] : ''
            }
          },
          {
            name: '姓名',
            prop: 'username',
            width: '150px'
          },
          {
            name: '时间',
            prop: 'ctime',
            width: '130px',
            fun: function (val) {
              if (!val) return ''
              const date = new Date(val)
              return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getDate()
            }
          },
          {
            name: 'IP',
            prop: 'ipaddress',
            width: '100px'
          },
          {
            name: '浏览器',
            prop: 'browsername',
            width: '100px'
          },
          {
            name: '操作系统',
            prop: 'osname',
            width: '100px'
          },
          {
            name: '说明',
            prop: 'description'
          }          
        ],
        log: [
          {
            name: '操作时间',
            prop: 'ctime',
            width: '130px',
            fun: function (val) {
              if (!val) return ''
              const date = new Date(val)
              return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getDate()
            }
          },
          {
            name: '操作人',
            prop: 'name'
          },
          {
            name: '行为',
            prop: 'type',
            width: '150px',
            fun: function (val) {
              const obj = {
                2: '添加部门管理员',
                3: '移除部门管理员',
                4: '删除成员',
                5: '密码修改'
              }
              return obj[val] ? obj[val] : ''
            }
          },
          {
            name: '对象',
            prop: 'haddlename'
          },
          {
            name: '详细描述',
            prop: 'description',
            width: '240px'
          }
        ]
      },
      tableInfo: [],
      isLoading: false,
      total: 0,
      query: {
        curpage: 1,
        pagesize: 20
      }
    }
  },
  props: {
    isAppenTitle: {
      type: Boolean,
      default: true
    },
    isSystemPersonal: {
      type: Boolean,
      default: false
    }
  },
  created () {
    this.getList()
  },
  computed: {
    isViewTitle(){
      const path = this.$route.path
      return path.includes('operationLog') && path !== '/operationLog' || this.isAppenTitle
    },
    isPersonal() {
      let flag = this.$route.fullPath.includes('userId')
      if (!flag) {
        flag = this.isSystemPersonal
      }
      return flag
    }
  },
  methods: {
    changeTabVal(){
      this.query.curpage = 1
      this.getList()
    },
    searchReset () {
      const search = { ...this.search }
      for (const item in search) {
        if (item === 'time') {
          search[item] = []
        } else {
          search[item] = ''
        }
      }
      this.search = search
      this.query.curpage = 1
      this.getList()
    },
    async getList () {
      const obj = { ...this.query }
      let res;
      if (this.search.time && this.search.time.length > 0) {
        obj.startTime = this.search.time[0]
        obj.endTime = this.search.time[1]
      }
      if (this.search.type) obj.type = this.search.type
      if (this.search.theWay && (this.search.input || this.search.input === 0)) {
        obj[this.search.theWay] = this.search.input
      }
      this.isLoading = true
      if (this.isPersonal) {
        let user = JSON.parse(localStorage.getItem('userMsg'))
        obj.userId = user.userId
      }
      if(this.tabVal === 'login'){
        res = await getuserloginlist(obj)
      }
      else{
        res = await getuserloglist(obj)
      }
      this.isLoading = false
      if (res.code === 0) {
        this.total = res.total
        this.tableInfo = res.data
      }
    },
    handleSizeChange (val) {
      this.query.curpage = 1
      this.query.pagesize = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.query.curpage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./css/common.scss";
.operationLog {
  width: 100%;
  height: 100%;
  .title{
    padding: 11px 7px 21px 7px;
  }
  .content {
    position: relative;
    height: calc(100% - 46px);
    padding: 20px;
    box-sizing: border-box;
    background: #fff;
    .tab-menu {
      position: absolute;
      left: 20px;
      top: 20px;
    }
    .search {
      clear: both;
      overflow: hidden;
      width: 100%;
      padding-left: 200px;
      box-sizing: border-box;
      .form {
        float: right;
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        padding-bottom: 15px;
        ::v-deep .el-form-item {
          display: flex;
          margin-bottom: 5px;
          .el-form-item__label {
            padding-left: 30px;
          }
        }
        ::v-deep .el-form-item:nth-child(1) {
          .el-form-item__label {
            padding-left: 0;
          }
        }
        ::v-deep .el-button {
          margin: 0 0 0 8px;
        }
        ::v-deep .el-button:first-child {
          margin: 0;
        }
      }
    }
    .table {
      clear: both;
      height: calc(100% - 110px);
      overflow: hidden;
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
